"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var Swiper_1 = require("../../../Swiper/Swiper");

var hooks_1 = require("../../../../hooks");

var __1 = require("../../..");

var styles = tslib_1.__importStar(require("./VerticalLodgingCard.style"));

var PriceInfo_1 = tslib_1.__importDefault(require("../../PriceInfo"));

var Swiper_2 = require("../../../Swiper");

function VerticalLodgingCard(_ref) {
  var className = _ref.className,
      id = _ref.id,
      imgSrc = _ref.imgSrc,
      thumbnailSrc = _ref.thumbnailSrc,
      title = _ref.title,
      subTitle = _ref.subTitle,
      unAvailableReason = _ref.unAvailableReason,
      rating = _ref.rating,
      priceDetail = _ref.priceDetail,
      stickers = _ref.stickers,
      caption = _ref.caption,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      onClickIsWished = _ref.onClickIsWished,
      onClickIsNotWished = _ref.onClickIsNotWished,
      _ref$isNew = _ref.isNew,
      isNew = _ref$isNew === void 0 ? false : _ref$isNew,
      _ref$isWished = _ref.isWished,
      isWished = _ref$isWished === void 0 ? false : _ref$isWished,
      _ref$hasVideo = _ref.hasVideo,
      hasVideo = _ref$hasVideo === void 0 ? false : _ref$hasVideo;

  var containerRef = react_1.useRef(null);

  var _react_1$useState = react_1.useState(isWished),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isWishedState = _react_1$useState2[0],
      setWished = _react_1$useState2[1];

  var _hooks_1$useResize = hooks_1.useResize(containerRef),
      width = _hooks_1$useResize.width;

  react_1.useEffect(function () {
    setWished(isWished);
  }, [isWished]);

  function handleClickWish() {
    if (isWishedState) {
      onClickIsNotWished && onClickIsNotWished(id, setWished);
      return;
    }

    onClickIsWished && onClickIsWished(id, setWished);
  }

  var imgSlides = react_1.useMemo(function () {
    return imgSrc.map(function (url, id) {
      return {
        id: id,
        url: url
      };
    });
  }, []);
  return jsx_runtime_1.jsxs("div", Object.assign({
    ref: containerRef,
    css: styles.container,
    className: className,
    onClick: function onClick() {
      return _onClick(id);
    }
  }, {
    children: [jsx_runtime_1.jsx(Swiper_2.Swiper, Object.assign({
      css: styles.coverImage(width),
      paginationType: Swiper_1.PaginationEnum.DYNAMICBULLETS,
      slides: imgSlides
    }, {
      children: function children(_ref2) {
        var url = _ref2.url,
            id = _ref2.id;
        return jsx_runtime_1.jsx(__1.ResponsiveImage, {
          src: url,
          lazy: "intersect",
          placeholderSrc: thumbnailSrc,
          alt: "lodging slide"
        }, id);
      }
    }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.tagContainer
    }, {
      children: [hasVideo && jsx_runtime_1.jsx(__1.Sticker, Object.assign({
        size: "small"
      }, __1.DEFINE_STICKERS.VIDEO), void 0), isNew && jsx_runtime_1.jsx(__1.Sticker, Object.assign({
        size: "small"
      }, __1.DEFINE_STICKERS.NEW), void 0)]
    }), void 0), jsx_runtime_1.jsx(__1.WishlistIcon, {
      css: styles.wishlistHeart,
      isWished: isWishedState,
      onClick: handleClickWish
    }, void 0), jsx_runtime_1.jsx("div", Object.assign({
      css: styles.title
    }, {
      children: title
    }), void 0), jsx_runtime_1.jsx("div", Object.assign({
      css: styles.subTitle
    }, {
      children: subTitle
    }), void 0), stickers && jsx_runtime_1.jsx("div", Object.assign({
      css: styles.stickerContainer
    }, {
      children: stickers.map(function (stickerProps) {
        return jsx_runtime_1.jsx(__1.Sticker, Object.assign({}, stickerProps, {
          size: "small"
        }), react_id_generator_1.default());
      })
    }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
      css: styles.review
    }, {
      children: [jsx_runtime_1.jsx("div", {
        children: (rating === null || rating === void 0 ? void 0 : rating.reviewCount) ? jsx_runtime_1.jsx(__1.RatingStarGrade, {
          size: "small",
          rating: rating.ratingValue,
          reviewCount: rating.reviewCount
        }, void 0) : jsx_runtime_1.jsx(__1.ReviewEvent, {}, void 0)
      }, void 0), jsx_runtime_1.jsx(PriceInfo_1.default, {
        salePrice: priceDetail.salePrice,
        originPrice: priceDetail.originPrice,
        discountRate: priceDetail.discountRate,
        caption: caption,
        isReservable: priceDetail.isReservable,
        unAvailableReason: unAvailableReason
      }, void 0)]
    }), void 0)]
  }), void 0);
}

exports.default = react_1.memo(VerticalLodgingCard);